module.exports = __webpack_public_path__ + "img/Flag_of_Uruguay.f639e129.svg";